import { z } from 'zod';

import { SPECIALS_CONTENT_FIELDS } from '@/constants/specials/specials.constants';
import { directusService, zodKeys } from '@/services/api.service';
import { mapSpecialsPageResponse } from '@/services/pages/specials/specials.service';
export const getSpecials = async () => {
  const { data } = await directusService.get('/items/specials_landing', {
    params: {
      fields: SPECIALS_CONTENT_FIELDS,
    },
  });

  return mapSpecialsPageResponse(data);
};

export const getUsedCars = async () => {
  const { data } = await directusService.get('/items/used_cars', {
    params: {
      fields: ['search_text, popular_text, specials_text', 'seo_data.*'],
    },
  });

  const dataPage = {
    seo: {
      ...data.seo_data,
    },
    contentText: {
      search_text: data.search_text,
      popular_text: data.popular_text,
      specials_text: data.specials_text,
    },
  };

  return dataPage;
};

export const getDemoCars = async () => {
  const { data } = await directusService.get('/items/demo_cars', {
    params: {
      fields: ['search_text, popular_text, specials_text', 'seo_data.*'],
    },
  });

  const dataPage = {
    seoDemo: {
      ...data.seo_data,
    },
    contentDemoText: {
      search_text: data.search_text,
      popular_text: data.popular_text,
      specials_text: data.specials_text,
    },
  };

  return dataPage;
};

export const getUsedCarsData = async (page: string) => {
  const { data } = await directusService.get(`/items/${page}`, {
    params: {
      fields: ['title, description', 'seo_data.*'],
    },
  });

  const dataPage = {
    seo: {
      ...data.seo_data,
    },
    contentText: {
      title: data.title,
      description: data.description,
    },
  };

  return dataPage;
};

export const getPages = async () => {
  const { data } = await directusService.get('/items/pages', {
    params: {
      fields: ['slug', 'text_content'],
    },
  });

  return data;
};

export const getTextContents = async () => {
  const { data } = await directusService.get('/items/text_content');

  return data;
};

export const getCookieBanner = async () => {
  const { data } = await directusService.get('/items/cookie_banner', {
    params: {
      fields: ['cookie_banner_text', 'status'],
    },
  });

  return data;
};

export const getVehicleDetailsBanner = async () => {
  const { data } = await directusService.get('/items/banner_vehicle_details', {
    params: {
      fields: ['image, title, link, url'],
    },
  });

  return data;
};

export const getFinanceFilterBanner = async () => {
  const { data } = await directusService.get('/items/banner_finance_filter', {
    params: {
      fields: ['image, title, description, button_text, url'],
    },
  });

  return data;
};

const ComparisonSectionItem = z.object({
  title: z.string(),
  description: z.string(),
  image: z.string(),
});

const RightToChooseSchema = z.object({
  id: z.number(),
  disclaimer: z.string(),
  isp_section: z.string(),
  comparison_section_items: z.array(ComparisonSectionItem).default([]),
  comparison_section_title: z.string(),
  header: z.string(),
  banner: z.string(),
});

export type RightToChoose = z.infer<typeof RightToChooseSchema>;

export const getYourRightChoosePage =
  async (): Promise<null | RightToChoose> => {
    const { data } = await directusService.get('/items/cms_right_to_choose', {
      params: {
        fields: zodKeys(RightToChooseSchema),
      },
    });

    const validatedData = RightToChooseSchema.safeParse(data);

    if (validatedData.success) {
      return validatedData.data;
    }
    return null;
  };
